import Scroll from './common/_scroll';
import Subpage from './common/_subpage';
const scroll = new Scroll();
const subpage = new Subpage();